import axios from 'axios';
import config from '../Config/config';

// axios defaults to no timeout, so a stalled connection never settles and leaves the
// candidate on a wordless spinner instead of the retryable answer the page has for it.
const REQUEST_TIMEOUT_MS = 15000;

export default class ConnectRepository {
  constructor() {
    this.connectAxios = axios.create({
      baseURL: config.urls.aryaConnectApi,
      timeout: REQUEST_TIMEOUT_MS,
    });
    this.connectV2Axios = axios.create({
      baseURL: config.urls.aryaConnectApiV2,
      timeout: REQUEST_TIMEOUT_MS,
    });
  }

  getConversation = (conversationId, inviteToken) => {
    return this.connectAxios.get(`invite/${conversationId}`, { params: { inviteToken } });
  }

  // Anonymous: the token goes in the body, never a query string that reaches logs and referers.
  resolveRescheduleContext = (eventId, token) => {
    return this.connectAxios.post('invite/reschedule/resolve', { Token: token }, { params: { eventId } });
  }

  resolveSlotProposal = (proposalId, token) => {
    return this.connectV2Axios.post(`calendar/proposal-invites/${encodeURIComponent(proposalId)}/resolve`, {
      Token: token,
    });
  }

  // Echoed back exactly as resolve sent it: a reformatted instant is a different slot.
  acceptSlotProposal = (proposalId, token, slotStartUtc) => {
    return this.connectV2Axios.post(`calendar/proposal-invites/${encodeURIComponent(proposalId)}/accept`, {
      Token: token,
      SlotStartUtc: slotStartUtc,
    });
  }

  resolveAvailabilityLink = (linkId, token) => {
    return this.connectV2Axios.post(`calendar/availability-links/${encodeURIComponent(linkId)}/resolve`, {
      Token: token,
    });
  }

  getAvailabilityForLink = (linkId, token, fromUtc, toUtc) => {
    return this.connectV2Axios.post(`calendar/availability-links/${encodeURIComponent(linkId)}/availability`, {
      Token: token,
      FromUtc: fromUtc,
      ToUtc: toUtc,
    });
  }

  // The zone is the one the times were shown in, so the confirmation is written in it.
  bookFromAvailabilityLink = (linkId, token, startUtc, timeZoneId) => {
    return this.connectV2Axios.post(`calendar/availability-links/${encodeURIComponent(linkId)}/book`, {
      Token: token,
      StartUtc: startUtc,
      TimeZoneId: timeZoneId,
    });
  }
}
